export default 'assets'
